<template>
  <div class="lightbox-alpha animated fadeIn">
    <a href="#" class="btn-close" @click="closeModal()">x</a>
    <div class="lightbox-content animated"><img :src="content" /></div>
    <a href="#" class="btn-share" @click="
                $openShare(
                  content,
                  'Anadolu Efes Spor Kulübü'
                  
                )
              ">Paylaş</a>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: ["closeModal", "content", "slug"],
  methods: {}
};
</script>

<style>
.lightbox-alpha {
  position: fixed;
  background: rgba(0, 0, 0, 0.85);
  height: 100vh;
  width: 100vw;
  z-index: 9999;
  opacity: 1;
  top: 0;
  left: 0;
}
.lightbox-content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    /*height: calc(100% - 50px);*/
    height: 90vh;
    width: 90vw;
    overflow: auto;
}

.lightbox-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
.lightbox-content img {
  width: 100%;
}
a.btn-close {
  position: absolute;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 32px;
  color: #ffffff;
  font-weight: bold;
  top: 20px;
  right: 20px;
  width: 37px;
  height: 32px;
  display: block;
  text-align: center;
  padding-top: 4px;
  padding-bottom: 0;
  line-height: 24px;
  transition: all 0.4s ease-out;
  z-index: 99;
}

a.btn-share {
  position: absolute;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 20px;
  color: #ffffff;
  font-weight: bold;
  bottom: 20px;
  right: 20px;
  height: 32px;
  display: block;
  text-align: center;
  padding-top: 4px;
  padding-bottom: 0;
  line-height: 24px;
  transition: all 0.4s ease-out;
  z-index: 99;
}

btn-close:hover {
  background-color: #cf3e2c;
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/Modal.vue